"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const application_logger_1 = require("../application-logger");
/**
 * Attempts to retry delivering a batch of events to the ingestionUrl up to `maxRetries` times
 * using exponential backoff.
 */
class BatchRetryManager {
    /**
     * @param config.retryInterval - The minimum retry interval in milliseconds
     * @param config.maxRetryDelayMs - The maximum retry delay in milliseconds
     * @param config.maxRetries - The maximum number of retries
     */
    constructor(delivery, config) {
        this.delivery = delivery;
        this.config = config;
    }
    /** Re-attempts delivery of the provided batch, returns the UUIDs of events that failed retry. */
    async retry(batch, context, attempt = 0) {
        const { retryIntervalMs, maxRetryDelayMs, maxRetries } = this.config;
        const delay = Math.min(retryIntervalMs * Math.pow(2, attempt), maxRetryDelayMs);
        application_logger_1.logger.info(`[BatchRetryManager] Retrying batch delivery of ${batch.length} events in ${delay}ms...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
        const { failedEvents } = await this.delivery.deliver(batch, context);
        if (failedEvents.length === 0) {
            application_logger_1.logger.info(`[BatchRetryManager] Batch delivery successfully after ${attempt + 1} tries.`);
            return [];
        }
        // attempts are zero-indexed while maxRetries is not
        if (attempt < maxRetries - 1) {
            return this.retry(failedEvents, context, attempt + 1);
        }
        else {
            application_logger_1.logger.warn(`[BatchRetryManager] Failed to deliver batch after ${maxRetries} tries, bailing`);
            return batch;
        }
    }
}
exports.default = BatchRetryManager;
//# sourceMappingURL=batch-retry-manager.js.map